import { atom } from "@podium/store";
import { RelatedSearch } from "src/types/RelatedSearch";

export type ErrorState = {
	hasError: boolean;
	errorType?: "client" | "server" | "network";
	statusCode?: number;
};

export type SuggestionStoreValue = {
	q?: string;
	suggestions?: RelatedSearch[];
	error?: ErrorState;
	isLoading?: boolean;
};

/**
 * Return the shared podium atom for suggestion state.
 * Using a helper prevents typos in channel/topic across imports.
 */
export function getSuggestionStore() {
	return atom<SuggestionStoreValue>("recommerce", "suggestions", {} as SuggestionStoreValue);
}

export function setSuggestions(suggestions: RelatedSearch[], q?: string, error?: ErrorState) {
	const store = getSuggestionStore();
	store.set({ q, suggestions, error, isLoading: false });
}

export function setSuggestionsLoading(q: string) {
	const store = getSuggestionStore();
	store.set({ q, isLoading: true });
}

export function setSuggestionsError(q: string, error: ErrorState) {
	const store = getSuggestionStore();
	store.set({ q, suggestions: [], error, isLoading: false });
}

export function clearSuggestionStore() {
	getSuggestionStore().set({});
}
